import React from 'react';
import {PRODUCTS} from '../../products';
import { useContext } from 'react';
import {useNavigate} from 'react-router-dom'
import {shopContext} from '../../context/shop-context';
import CartItem from './cartItem';
import './cartItem.css'
function Cart() {
  const {cartValue,TotalPrice}=useContext(shopContext);
  const totalAmount=TotalPrice();
  const navigate=useNavigate();
  return (
    <div className='cart-main'>
      {
        PRODUCTS.map((product)=>{
          if(cartValue[product.id]!=0){
            return <CartItem data={product}/>
          }
          else{
            
          }
        })
      }
      {
        totalAmount>0?
        <div className='checkout'>
        <p>Total Price {totalAmount}</p>
        <button className='checkout-btn'>Checkout</button>
        <button onClick={()=>navigate('/')} className='checkout-btn'>Continue Shopping</button>
        </div>
        :<h1>Your cart is Empty</h1>
      }
    </div>
  );
}

export default Cart;
